import React, { useEffect, useState } from "react";
import Button from "../../../Components/Common/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { setTriggerRazorpay } from "../../../Views/AfterAuth/WalletView/redux/walletSlice";
import { useNavigate } from "react-router-dom";
import { Pathname } from "../../../Router/Pathname";
import { resetExpireAllPayments } from "../Redux/reducer";

const WalletCard = ({ payment, order_id, returnFromRazorpay, index,isLatestPayment}) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false); // new state
  const [isExpired, setIsExpired] = useState(false);
  const [timerLeft,setTimerLeft] = useState(180);
  const { expireAllPayments } = useSelector((store) => store.chatBot);
  const { returnFromRazorpay: hasReturnedFromRazorpay } = useSelector((store) => store.chatBot);

  if (!payment) {
    return null; // Return nothing if payment data is empty
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAddMoney = () => {
    setIsButtonClicked(true);
    localStorage.setItem("lastProcessedOrderId", order_id);
    dispatch(setTriggerRazorpay(true));
    navigate(`${Pathname.START_CHARGING}/add-money`, {
      state: { orderId: order_id, fromChatBot: true,
    },
    });
  };

  useEffect(() => {
    if (expireAllPayments) {
      setIsExpired(true);
      setTimerLeft(0);
      // Reset the flag after handling it
      dispatch(resetExpireAllPayments(false));
    }
  }, [expireAllPayments, dispatch]);

    // Disable previous payment links when a new one is created
    useEffect(() => {
      if (!isLatestPayment && !isExpired) {
        setIsExpired(true);
        setTimerLeft(0);
      }
    }, [isLatestPayment]);

   // Check if this specific payment link should be expired based on order_id
   useEffect(() => {
    if (hasReturnedFromRazorpay && localStorage.getItem("lastProcessedOrderId") === order_id) {
      setIsExpired(true);
      setTimerLeft(0);
    }
  }, [hasReturnedFromRazorpay, order_id]);

  useEffect(()=>{
    if(!payment?.paymentDetails?.paymentCreatedAt){
      return;
    }
    const createdAt=new Date(payment?.paymentDetails?.paymentCreatedAt).getTime();
    const now=Date.now()
    const expirationTime=createdAt+180000;//3 min expire timerLeft
    const remainingTime=expirationTime-now;
    
    if(remainingTime<=0){
      setIsExpired(true);
      return;
    }
    const timerId=setInterval(()=>{
      setTimerLeft((prevTimer)=>{
        if(prevTimer==0){
          clearInterval(timerId);
          setIsExpired(true)
          return 0;
        }
        return prevTimer-1;
      });
    },1000)

    const expire=setTimeout(()=>{
      setIsExpired(true);
    },remainingTime);

    return ()=>{
      clearTimeout(expire);
      clearInterval(timerId);
    };

  },[payment?.paymentDetails?.paymentCreatedAt])

  return (
    <div className="payment-container">
      <p className="payment-header">{payment.message}</p>
      <div className="payment-card">
        <p className="payment-title">Top up of</p>
        <h2 className="payment-amount">{payment.amount}</h2>
        <Button
          text={isExpired?"Expired":`${payment.buttonText}`}
          className="payment-button"
          onClick={handleAddMoney}
          // disabled={location.state?.clickedButtons?.[index] || payment.disable}
          disabled={isButtonClicked || isExpired}
        />
      </div>
    </div>
  );
};

export default WalletCard;
